import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchComplianceCentre = createAsyncThunk('complianceCentre/fetch', async (range, { rejectWithValue, signal }) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/compliance/centre?${new URLSearchParams(range)}`, {
      signal, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Unable to load compliance centre');
    if (!result.data || result.data.range?.startDate !== range.startDate || result.data.range?.endDate !== range.endDate) throw new Error('Invalid compliance centre response');
    return result.data;
  } catch (error) { return rejectWithValue(error.message || 'Unable to load compliance centre'); }
});
